import { render } from "./BuyerSectionItem.vue?vue&type=template&id=db6fc218&scoped=true"
import script from "./BuyerSectionItem.vue?vue&type=script&lang=js"
export * from "./BuyerSectionItem.vue?vue&type=script&lang=js"

import "./BuyerSectionItem.vue?vue&type=style&index=0&id=db6fc218&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6fc218"]])

export default __exports__